// extracted by mini-css-extract-plugin
export default {"content":"FormPage_content__akxxx","isSubPage":"FormPage_isSubPage__RurqZ","buttons":"FormPage_buttons__vOQxk"};